
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.77 1.435h.05V.05h1.284v1.385h9.792V.05h1.285v1.385h.742c1.114 0 2.027.913 2.027 2.027v12.461a2.034 2.034 0 01-2.027 2.027H2.077A2.034 2.034 0 01.05 15.923V3.462c0-1.114.913-2.027 2.027-2.027h.692zm.05 1.334v-.05h-.743a.733.733 0 00-.742.743v2.126h15.33V3.462a.733.733 0 00-.742-.743h-.742v1.385h-1.285V2.719H4.104v1.385H2.819V2.769zM1.384 6.873h-.05v9.05c0 .417.325.742.742.742h13.846a.733.733 0 00.742-.742v-9.05H1.385zm5.488 2.77H5.588V8.357h1.285v1.284zm2.77 0H8.357V8.357h1.284v1.284zm2.768 0h-1.284V8.357h1.284v1.284zm2.77 0h-1.285V8.357h1.285v1.284zM4.104 12.41H2.819v-1.284h1.285v1.284zm2.77 0H5.587v-1.284h1.285v1.284zm2.768 0H8.358v-1.284h1.284v1.284zm2.77 0h-1.285v-1.284h1.284v1.284zm2.769 0h-1.285v-1.284h1.285v1.284zM4.104 15.18H2.819v-1.285h1.285v1.285zm2.77 0H5.587v-1.285h1.285v1.285zm2.768 0H8.358v-1.285h1.284v1.285z","fill":"#fff","stroke":"#808486","stroke-width":".1"}})])
          )
        }
      }
    